import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang } = useGlobal();
    const { t } = useLang('homebattery');
    return (
        <div id="D" className={`home-battery-D home-battery-box ${css['home-battery-D']}`}>
            <h2 className="title">{t('secD_title')}</h2>
            <div className="img-box">
                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950031621/img04.jpg" alt={t('secD_title')} />
            </div>
            <p className="desc">
                {t.rich('secD_desc', {
                    s: (text: string) => <span className="strong">{text}</span>,
                })}
            </p>
        </div>
    );
}
